<template>
  <div class="login">
    <div class="content">
      <div class="bg"></div>
      <div class="df aic jcc form">
        <div class="fg1">
          <div class="title">{{ projectName }}</div>

          <!-- 登录方式切换标签 -->
          <el-tabs v-model="activeTab" class="login-tabs">
            <el-tab-pane label="钉钉扫码登录" name="dingtalk" v-if="dingTalkConfig.enabled">
              <div class="dingtalk-login">
                <div id="dingtalk_qrcode_container" class="qrcode-container"></div>
                <div class="qrcode-tip">请使用钉钉App扫码登录</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号密码登录" name="password">
              <el-form
                :model="loginForm"
                :rules="loginRules"
                ref="loginForm"
                class="loginForm is-success"
                label-width="0px"
              >
                <el-form-item prop="username" class="mb36">
                  <el-input
                    @keyup.enter.native="submitForm('loginForm')"
                    v-model="loginForm.username"
                    class="pctw100 input"
                    placeholder="账号"
                  >
                    <i slot="prefix" class="iconfont iconuser-fill"></i>
                  </el-input>
                </el-form-item>

                <el-form-item prop="password" class="mb36">
                  <el-input
                    @keyup.enter.native="submitForm('loginForm')"
                    :type="passwordType"
                    class="pctw100 input"
                    v-model="loginForm.password"
                    placeholder="密码"
                  >
                    <i slot="prefix" class="iconfont iconlock-fill"></i>
                    <i
                      slot="suffix"
                      @click="showPwd"
                      :class="
                        passwordType == 'password'
                          ? 'iconfont iconeyeslash-fill'
                          : 'iconfont iconeye-fill'
                      "
                    ></i>
                  </el-input>
                </el-form-item>

                <div class="btns">
                  <el-button
                    class="loginBtn"
                    type="primary"
                    :loading="btnload"
                    @click="submitForm('loginForm')"
                  >
                    登 录
                  </el-button>
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <jigsaw
      ref="captcha"
      v-if="show"
      :show="show"
      @close="show = false"
      :router="'/'"
      :loginForm="loginForm"
      :register="() => {}"
      :login="validPwd"
    ></jigsaw>
  </div>
</template>
<script>
import { projectName, dingTalkConfig } from '@/config';
export default {
  name: 'loginCpt',
  components: {},
  data() {
    return {
      show: false, //是否显示验证码组件
      isVerifiCode: false, //是否开启验证码校验
      passwordType: 'password',
      projectName: projectName,
      btnload: false,
      activeTab: dingTalkConfig.enabled ? 'dingtalk' : 'password', // 当前激活的登录方式标签，根据配置决定默认值
      dingTalkConfig: dingTalkConfig, // 钉钉配置
      dingTalkLoginInstance: null, // 存储钉钉登录实例
      isProcessingDingTalkLogin: false, // 防止重复处理钉钉登录
      loginForm: {
        username: null,
        password: null
      },
      loginRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.getPermission();
  },
  mounted() {
    // 重置钉钉登录相关状态
    this.resetDingTalkLoginState();
    // 页面加载完成后检查URL参数，处理钉钉回调
    this.handleDingTalkCallback();
    this.initDingTalkLogin();
  },
  watch: {
    activeTab(newTab, oldTab) {
      if (newTab === 'dingtalk') {
        // 切换到钉钉登录时重置状态并初始化二维码
        this.$nextTick(() => {
          this.resetDingTalkLoginState();
          this.initDingTalkLogin();
        });
      } else if (oldTab === 'dingtalk') {
        // 切换离开钉钉登录时销毁实例
        this.destroyDingTalkInstance();
      }
    }
  },
  methods: {
    //督促更新密码
    promptPwd() {
      this.$api.formPost('/api/auth/sysuser/promptUpdatePassword', {}).then((res) => {
        res.retBody && this.$message.success(res.retBody);
      });
    },
    //获取用户默认配置
    getUserSetting() {
      return new Promise((resolve, reject) => {
        if (!this.getGlobalConfig().getUserIndiviality) {
          resolve();
          return;
        }
        this.$api.formPost('/api/auth/sysuserprofile/doGetUserIndiviality', {}).then((res) => {
          if (res.retHead.code === '0000000') {
            this.$store.commit('setSetting', res.retBody);
          } else {
            this.$store.commit('setSetting', null);
          }
          resolve();
        });
      });
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$jhEncrypt) {
            this.loginForm.commitPwd = this.$jhEncrypt.pwdInfoEncrypt(this.loginForm.password);
          }
          if (this.isVerifiCode) {
            this.show = true;
          } else {
            const params = {
              username: this.loginForm.username,
              password: this.loginForm.commitPwd
            };
            this.login(params);
          }
        } else {
          return false;
        }
      });
    },
    login(params) {
      if (this.$jhEncrypt) {
        params.username = this.$jhEncrypt.transferInfoEncrypt(params.username);
        params.password = this.$jhEncrypt.transferInfoEncrypt(params.password);
      }
      // console.log(params.password);
      this.$api
        .formPost('/web/sysuser/login', params)
        .then((res) => {
          this.btnload = false;
          if (res.retHead.code == '0000000' && res.retBody) {
            const user = JSON.stringify(res.retBody);
            sessionStorage.setItem('token', res.retBody.token);
            sessionStorage.setItem('user', user);
            this.validPwd();
          } else {
            this.$message.error(res.retHead.message);
          }
        })
        .catch((error) => {
          this.btnload = false;
        });
    },
    async finishLoginSuccess(successMessage) {
      this.$message.success(successMessage);
      this.$router.push('/');
    },
    //简单密码提示
    async editPwd() {
      await this.getUserSetting();
      this.$confirm('您的密码强度较低,是否前往修改密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.promptPwd();
          this.$router.push('/user/mod-user?type=2');
        })
        .catch(() => {
          this.promptPwd();
          this.$router.push('/');
        });
    },
    //验证码校验
    async validPwd() {
      this.show = false;
      await this.getUserSetting();
      if (this.isVerifiCode) {
        if (!this.$validPwd(this.loginForm.password).result) {
          this.editPwd();
        } else {
          this.promptPwd();
          await this.finishLoginSuccess('登录成功！');
        }
      } else {
        if (!this.$validPwd(this.loginForm.password).result) {
          this.editPwd();
        } else {
          this.promptPwd();
          await this.finishLoginSuccess('登录成功！');
        }
      }
    },
    //检查是否需要验证码
    getPermission() {
      this.$api.formPost('/captcha/status', {}).then(
        (res) => {
          if (res.retHead.code === '0801001') {
            this.isVerifiCode = false;
          } else if (res.retHead.code === '0000000') {
            this.isVerifiCode = res.retBody;
          }
        },
        (err) => {
          this.isVerifiCode = false;
        }
      );
    },
    // 重置钉钉登录状态
    resetDingTalkLoginState() {
      console.log('重置钉钉登录状态');
      this.isProcessingDingTalkLogin = false;
      this.btnload = false;

      // 销毁现有的钉钉登录实例
      this.destroyDingTalkInstance();
    },

    // 销毁钉钉登录实例
    destroyDingTalkInstance() {
      if (this.dingTalkLoginInstance && typeof this.dingTalkLoginInstance.destroy === 'function') {
        try {
          console.log('销毁钉钉登录实例');
          this.dingTalkLoginInstance.destroy();
        } catch (error) {
          console.warn('销毁钉钉登录实例时出错:', error);
        } finally {
          this.dingTalkLoginInstance = null;
        }
      }

      // 清空二维码容器
      const container = document.getElementById('dingtalk_qrcode_container');
      if (container) {
        container.innerHTML = '';
      }
    },

    // 初始化钉钉二维码登录
    initDingTalkLogin() {
      if (!this.dingTalkConfig.enabled) {
        console.log('钉钉登录未启用');
        return;
      }

      if (window.DTFrameLogin) {
        const { corpId, clientId } = this.dingTalkConfig;
        const redirectUri = encodeURIComponent(
          window.location.origin + window.location.pathname + '#/login'
        );
        console.log('初始化钉钉登录，重定向URI:', redirectUri);

        // 确保完全销毁旧实例
        this.destroyDingTalkInstance();

        // 等待一小段时间确保DOM清理完成
        this.$nextTick(() => {
          // 重置状态
          this.isProcessingDingTalkLogin = false;

          try {
            // eslint-disable-next-line new-cap
            this.dingTalkLoginInstance = window.DTFrameLogin(
              {
                id: 'dingtalk_qrcode_container',
                width: 198,
                height: 198
              },
              {
                redirect_uri: redirectUri,
                client_id: clientId,
                scope: 'openid corpid',
                response_type: 'code',
                state: Date.now().toString(), // 使用时间戳作为state，确保唯一性
                prompt: 'consent',
                corpId: corpId
              },
              (loginResult) => {
                const { redirectUrl, authCode, state } = loginResult;
                console.log('钉钉登录成功:', { authCode, state });
                // 处理登录成功，传入state用于验证
                this.handleDingTalkLoginSuccess(authCode, state);
              },
              (errorMsg) => {
                console.error('钉钉登录失败:', errorMsg);
                this.$message.error(`钉钉登录失败: ${errorMsg}`);
                // 登录失败时重置状态
                this.isProcessingDingTalkLogin = false;
              }
            );
            console.log('钉钉登录实例创建成功');
          } catch (error) {
            console.error('创建钉钉登录实例失败:', error);
            this.$message.error('初始化钉钉登录失败，请刷新页面重试');
          }
        });
      } else {
        // 如果SDK还未加载完成，延迟重试
        setTimeout(() => {
          this.initDingTalkLogin();
        }, 100);
      }
    },
    // 处理钉钉登录成功
    async handleDingTalkLoginSuccess(authCode, state) {
      // 防止重复处理
      if (this.isProcessingDingTalkLogin) {
        console.log('钉钉登录正在处理中，忽略重复请求');
        return;
      }

      try {
        this.isProcessingDingTalkLogin = true;
        this.btnload = true;
        console.log('开始处理钉钉登录，authCode:', authCode, 'state:', state);

        // 调用后端接口验证钉钉授权码并获取用户信息
        const res = await this.$api.formPost('/dingTalk/dingTalkLogin', {
          authCode: authCode,
          state: state
        });

        this.btnload = false;
        if (res.retHead.code === '0000000' && res.retBody) {
          const user = JSON.stringify(res.retBody);
          sessionStorage.setItem('token', res.retBody.token);
          sessionStorage.setItem('user', user);

          // 销毁钉钉实例，防止重复使用
          this.destroyDingTalkInstance();

          // 获取用户设置并跳转
          await this.getUserSetting();
          await this.finishLoginSuccess('钉钉登录成功！');
        } else {
          this.$message.error(res.retHead.message || '钉钉登录失败');
          // 登录失败时重置状态，允许重试
          this.resetDingTalkLoginState();
          // 重新初始化登录
          this.$nextTick(() => {
            this.initDingTalkLogin();
          });
        }
      } catch (error) {
        this.btnload = false;
        console.error('钉钉登录处理失败:', error);
        this.$message.error('钉钉登录处理失败，请重试');
        // 错误时重置状态并重新初始化
        this.resetDingTalkLoginState();
        this.$nextTick(() => {
          this.initDingTalkLogin();
        });
      }
    },
    // 处理钉钉回调（如果是通过重定向方式）
    handleDingTalkCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      if (code && state) {
        console.log('检测到钉钉回调:', { code, state });
        // 如果检测到钉钉回调参数，自动处理登录
        this.handleDingTalkLoginSuccess(code, state);
        // 清理URL参数
        const newUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
      }
    }
  },
  // 组件销毁时清理钉钉登录实例
  beforeDestroy() {
    console.log('组件销毁，清理钉钉登录实例');
    this.destroyDingTalkInstance();
  },

  // 组件激活时重置状态（用于keep-alive场景）
  activated() {
    console.log('组件激活，重置钉钉登录状态');
    if (this.activeTab === 'dingtalk') {
      this.resetDingTalkLoginState();
      this.$nextTick(() => {
        this.initDingTalkLogin();
      });
    }
  },

  // 组件停用时清理实例（用于keep-alive场景）
  deactivated() {
    console.log('组件停用，销毁钉钉登录实例');
    this.destroyDingTalkInstance();
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item__content .el-input {
    width: 100% !important;
  }
}
.login {
  width: 100%;
  height: 100vh;
  min-height: 600px;
  display: flex;
  background: url('../../../assets/images/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;

  .content {
    width: min(85vw, 1400px);
    height: min(80vh, 750px);
    min-height: 500px;
    max-height: 850px;
    background: #fff;
    border-radius: clamp(15px, 2vw, 25px);
    display: flex;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    .bg {
      flex: 0.7;
      min-width: 300px;
      background: url('../../../assets/images/ssd.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-radius: clamp(15px, 2vw, 25px) 0px 0px clamp(15px, 2vw, 25px);
    }

    .form {
      flex: 1.3;
      min-width: 350px;
      max-width: 700px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: clamp(2rem, 4vw, 4rem);
      box-sizing: border-box;

      .title {
        font-size: clamp(24px, 4vw, 36px);
        margin-bottom: clamp(20px, 3vw, 40px);
        text-align: center;
        font-weight: 600;
        color: #333;
      }

      .savePwd {
        margin-bottom: clamp(20px, 3vw, 40px);
        margin-left: 5px;
      }
    }
  }

  // 超大屏幕适配 (≥1440px)
  @media screen and (min-width: 1440px) {
    .content {
      width: min(80vw, 1600px);
      height: min(85vh, 900px);
      max-height: 1000px;

      .form {
        padding: clamp(3rem, 5vw, 6rem);

        .title {
          font-size: clamp(32px, 4vw, 42px);
          margin-bottom: clamp(30px, 4vw, 50px);
        }
      }
    }
  }

  // 超超大屏幕适配 (≥1920px)
  @media screen and (min-width: 1920px) {
    .content {
      width: min(75vw, 1800px);
      height: min(75vh, 900px);

      .form {
        .title {
          font-size: clamp(36px, 3vw, 48px);
        }
      }
    }
  }

  // 平板设备适配
  @media screen and (max-width: 1024px) {
    padding: 1rem;

    .content {
      width: 95vw;
      height: auto;
      min-height: 450px;
      flex-direction: column;

      .bg {
        height: 200px;
        min-width: unset;
        border-radius: clamp(15px, 2vw, 25px) clamp(15px, 2vw, 25px) 0 0;
      }

      .form {
        min-width: unset;
        padding: clamp(1.5rem, 3vw, 3rem);
      }
    }
  }

  // 手机设备适配
  @media screen and (max-width: 768px) {
    padding: 0.5rem;

    .content {
      width: 98vw;
      min-height: 400px;

      .bg {
        height: 150px;
      }

      .form {
        padding: clamp(1rem, 2vw, 2rem);

        .title {
          font-size: clamp(20px, 5vw, 28px);
          margin-bottom: clamp(15px, 2vw, 25px);
        }
      }
    }
  }

  // 超小屏幕适配
  @media screen and (max-width: 480px) {
    .content {
      .bg {
        height: 120px;
      }
    }
  }
}
.mb36 {
  margin-bottom: clamp(20px, 3vw, 36px);
}

// 表单元素响应式样式
::v-deep .loginForm .el-form-item__content {
  margin-right: 0px !important;
}

::v-deep .el-form-item {
  margin-bottom: clamp(16px, 2vw, 22px) !important;
}

::v-deep .input .el-input__inner {
  height: clamp(40px, 5vw, 48px);
  line-height: clamp(40px, 5vw, 48px);
  border-radius: clamp(20px, 4vw, 32px);
  padding-left: clamp(35px, 4vw, 45px);
  font-size: clamp(14px, 2vw, 18px);
  transition: all 0.3s ease;
  border: 2px solid #e6e6e6;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  }
}

::v-deep .input .el-input__prefix {
  display: flex;
  align-items: center;
  margin-left: clamp(6px, 1vw, 8px);

  .iconfont {
    font-size: clamp(16px, 2vw, 20px);
    color: #999;
  }
}

::v-deep .input .el-input__suffix {
  display: flex;
  align-items: center;
  margin-right: clamp(6px, 1vw, 8px);

  .iconfont {
    font-size: clamp(16px, 2vw, 20px);
    color: #999;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #409eff;
    }
  }
}

::v-deep .loginBtn {
  height: clamp(40px, 5vw, 48px);
  font-size: clamp(16px, 2.5vw, 24px) !important;
  width: 100%;
  border-radius: clamp(20px, 4vw, 32px);
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(64, 158, 255, 0.3);
  }
}

::v-deep .el-checkbox__label {
  font-size: clamp(14px, 2vw, 18px);
}

::v-deep .el-input input:-webkit-autofill::first-line {
  font-size: clamp(16px, 2.5vw, 24px);
}

// 大屏幕下的表单样式优化
@media screen and (min-width: 1440px) {
  ::v-deep .input .el-input__inner {
    height: clamp(48px, 6vw, 56px);
    line-height: clamp(48px, 6vw, 56px);
    font-size: clamp(18px, 2.5vw, 22px);
    padding-left: clamp(45px, 5vw, 55px);
  }

  ::v-deep .loginBtn {
    height: clamp(48px, 6vw, 56px);
    font-size: clamp(20px, 3vw, 28px) !important;
  }

  ::v-deep .input .el-input__prefix .iconfont,
  ::v-deep .input .el-input__suffix .iconfont {
    font-size: clamp(20px, 2.5vw, 24px);
  }
}

// 平板和手机设备下的表单样式优化
@media screen and (max-width: 768px) {
  ::v-deep .input .el-input__inner {
    padding-left: 40px;
    font-size: 16px;
  }

  ::v-deep .loginBtn {
    font-size: 18px !important;
  }
}

/* 钉钉登录相关样式 */
.login-tabs {
  width: 100%;

  ::v-deep .el-tabs__header {
    margin: 0 0 clamp(20px, 3vw, 30px) 0;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    display: none;
  }

  ::v-deep .el-tabs__item {
    font-size: clamp(14px, 2vw, 16px);
    color: #666;
    padding: 0 clamp(15px, 2vw, 20px);
    transition: color 0.3s ease;

    &:hover {
      color: #409eff;
    }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #409eff;
    font-weight: 600;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #409eff;
    transition: all 0.3s ease;
  }
}
.dingtalk-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(15px, 2vw, 20px) 0;

  .qrcode-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    margin-top: -10px;
    min-height: 242px;
    width: 100%;
    overflow: hidden;
    position: relative;

    // 钉钉二维码容器样式
    ::v-deep iframe {
      border: 1px solid #e6e6e6;
      border-radius: clamp(8px, 1.5vw, 12px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 6px rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.3s ease;
      max-width: 100%;
      max-height: 100%;
      width: 250px !important;
      height: 250px !important;
      object-fit: contain;
      .module-qrcode-code {
        top: 45% !important;
      }

      &:hover {
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), 0 3px 8px rgba(0, 0, 0, 0.08);
      }
    }
  }

  .qrcode-tip {
    color: #666;
    font-size: clamp(12px, 1.5vw, 14px);
    text-align: center;
    margin-top: clamp(8px, 1vw, 10px);
    padding: 0 1rem;
  }

  // 大屏幕优化
  //   @media screen and (min-width: 1440px) {
  //     .qrcode-container {
  //       min-height: clamp(275px, 27.5vw, 308px);

  //       ::v-deep iframe {
  //         width: clamp(253px, 22vw, 286px) !important;
  //         height: clamp(253px, 22vw, 286px) !important;
  //       }
  //     }

  //     .qrcode-tip {
  //       font-size: clamp(14px, 1.8vw, 18px);
  //     }
  //   }

  //   // 中等屏幕优化（平板横屏）
  //   @media screen and (min-width: 1024px) and (max-width: 1439px) {
  //     .qrcode-container {
  //       min-height: clamp(220px, 24.2vw, 264px);

  //       ::v-deep iframe {
  //         width: clamp(198px, 19.8vw, 220px) !important;
  //         height: clamp(198px, 19.8vw, 220px) !important;
  //       }
  //     }
  //   }

  //   // 小屏幕优化（平板竖屏或小窗口）
  //   @media screen and (min-width: 769px) and (max-width: 1023px) {
  //     .qrcode-container {
  //       min-height: clamp(187px, 22vw, 220px);

  //       ::v-deep iframe {
  //         width: clamp(176px, 19.8vw, 198px) !important;
  //         height: clamp(176px, 19.8vw, 198px) !important;
  //       }
  //     }
  //   }

  //   // 移动端优化
  //   @media screen and (max-width: 768px) {
  //     .qrcode-container {
  //       min-height: 187px;

  //       ::v-deep iframe {
  //         width: 187px !important;
  //         height: 187px !important;
  //       }
  //     }
  //   }

  //   @media screen and (max-width: 480px) {
  //     .qrcode-container {
  //       min-height: 165px;

  //       ::v-deep iframe {
  //         width: 165px !important;
  //         height: 165px !important;
  //       }
  //     }
  //   }
}
</style>
